import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-margarita-flights',
  templateUrl: './margarita-flights.component.html',
  styleUrls: ['./margarita-flights.component.scss']
})
export class MargaritaFlightsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/margarita-flights/margarita-flights.component.ts